import Dexie from 'dexie';

export default class StoreUtils {

  static STORE_PREFIX = "AnatomyStuff";

  static APP_TYPE = process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'Vet' : 'Physio'

  static generateStoreName(uniqueId, storeName) {
    return `${this.STORE_PREFIX}-${uniqueId}-${StoreUtils.APP_TYPE}-${storeName}`;
  }

  static createDexieUserDB(uniqueId, storeName) {
    const dbName = StoreUtils.generateStoreName(uniqueId, storeName);
    console.log(`createDexieUserStore dbName: ${dbName}`);
    return new Dexie(dbName);
  }

} // StoreUtils
